import { render, staticRenderFns } from "./AttributesSideBar.vue?vue&type=template&id=3eff5c14"
import script from "./AttributesSideBar.vue?vue&type=script&lang=ts"
export * from "./AttributesSideBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports